import { createContext, useContext, useEffect, useReducer, useState } from "react";
import reducer from "./Blogreducer";
import { BASE_URL } from "../../Config/Config";
const Blogcontext = createContext();

const API = `${BASE_URL}/blogpost`;
const Allblogapi = `${BASE_URL}/blogpost`;


const intialstate = {
  Allblogdata:[],
  filterblogdata:[],
  duplicateblog:[],
  Blogdata : [],
  singleblog:[],
  filters:{
    text:"",
    categoryname:[],
    Tag:"",
  }
}

const  Blogprovider = ({children})=>{
    const [state , dispatch ] = useReducer(reducer , intialstate );
    const [blogloading , setblogloading] = useState(true);
    const [allBlogloading , setallBlogloading] = useState(true);
const getBlogdata = async (URL)=>{
    try {
        const response =  await fetch(URL,{
            method: "GET",
            headers: {
              'content-type': "application/json"
            },
            credentials: "include",
        });
        if(!response){
            console.log("faild fatching data");
         }
         else{
            const Blogdata =  await response.json();
            dispatch({type : 'SET_BLOG_API' , payload : Blogdata.data })
         }
    } catch (error) {
        console.log(error);
    }
}
const getALLblogdata = async (Allblogapi)=>{
    try {
      setallBlogloading(true);
        const response =  await fetch(Allblogapi,{
            method: "GET",
            headers: {
              'content-type': "application/json"
            },
            credentials: "include",
        });
        if(!response){
            console.log("faild fatching data");
         }
         else{
            const allBlogdata =  await response.json();
            dispatch({type : 'SET_All_BLOG_API' , payload : allBlogdata.data });
            
         }
    } catch (error) {
        console.log(error);
    }
    finally{
            setallBlogloading(false);
    }
}

const Getsinglblog = async (slug) => {
  console.log("Fetching blog with ID:", slug);
  try {
    setblogloading(true);
    // Fetch blog data from the backend API
    const response = await fetch(`${BASE_URL}/blogpost/${slug}`);
    const data = await response.json();

    if ( data) {
      // If blog data is found, dispatch the action
      dispatch({ type: "SET_SINGLE_BLOG", payload: data.data });
      console.log("Blog found:", data.data);
    } else {
      // If no blog is found, handle the case
      console.warn(`Blog with ID ${slug} not found.`);
      dispatch({ type: "SET_SINGLE_BLOG", payload: null });
    }
  } catch (error) {
    // Handle any errors during the API call
    console.error("Error fetching blog:", error);
    dispatch({ type: "SET_SINGLE_BLOG", payload: null });
  }
  finally{
        setblogloading(false);

  }
};


 useEffect(()=>{
    getBlogdata(API);
 },[])


 useEffect(()=>{
  getALLblogdata(Allblogapi);
 },[]);

 const updatefiltervalue =(event)=>{
  const {name , value} =  event.target;
 dispatch({type : "UPDATE_FILTER" , payload: {name , value}});
 }

 const updatetag = (tagValue) => {
  dispatch({type: "FILTER_BLOG_TAG", payload: { tagname: "Tag", tagvalue: tagValue },
   });
};

const showallblog = ()=>{
  dispatch({type:"SET_ALL_DATA"});
}

  useEffect(()=>{
     dispatch({type:"SET_BLOG_FILTER"});
  },[state.filters]);


   return(
 <Blogcontext.Provider value={{...state , Getsinglblog , updatefiltervalue , updatetag , showallblog , blogloading , allBlogloading}}>
        {children}
 </Blogcontext.Provider>
   );
}


const Useglobelcontext =  ()=>{
   return useContext(Blogcontext);
}

export { Blogprovider ,Useglobelcontext , Blogcontext }
